/* src/app/dashboard/charts/top-senders/top-senders.component.css */
.canvas-container {
}
canvas {
  height: 500px;
}
.mat-mdc-card-content {
  overflow: hidden;
}
@media (max-width: 600px) {
  .canvas-container {
    height: 100%;
  }
  .mat-mdc-card-content {
    height: 80%;
  }
  canvas {
    height: 100%;
  }
}
/*# sourceMappingURL=top-senders.component.css.map */
